module.exports = __webpack_public_path__ + "img/5.59047279.png";